// import React from 'react';

// const FileInput = ({ field, form, ...props }) => {
//   const handleChange = (event) => {
//     const files = event.currentTarget.files;
//     form.setFieldValue(field.name, files);
//   };

//   return (
//     <input
//       type="file"
//       onChange={handleChange}
//       multiple={props.multiple}
//       accept={props.accept}
//     />
//   );
// };

// export default FileInput;

import React, { useState, useRef } from "react";

const FileInput = ({ field, form, ...props }) => {
  const [previews, setPreviews] = useState([]);
  const fileInputRef = useRef(null); // Ref to access the hidden file input

  const handleChange = (event) => {
    const files = Array.from(event.currentTarget.files);
    if (files.length > 0) {
      // Update Formik's field value with the array of files
      form.setFieldValue(field.name, files);

      // Create previews for each selected file
      const newPreviews = files.map((file) => {
        return new Promise((resolve) => {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            resolve(fileReader.result);
          };
          fileReader.readAsDataURL(file);
        });
      });

      Promise.all(newPreviews).then((results) => {
        setPreviews(results);
      });
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click(); // Trigger the file input click
  };

  return (
    <div>
      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleChange}
        multiple={props.multiple}
        accept={props.accept}
        style={{ display: "none" }} // Hide the file input
      />

      {/* Custom image button */}
      <img
        src="images/camera.png" // Replace with the path to your image
        alt="Upload"
        onClick={handleImageClick}
        style={{ cursor: "pointer", maxWidth: "50px" }} // Adjust style as needed
      />

      {/* Display previews if available */}
      {previews.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "10px",marginBottom:"10px" }}>
          {previews.map((preview, index) => (
            <img
              key={index}
              src={preview}
              alt={`Preview ${index}`}
              style={{ maxWidth: "100px", height: "auto", marginRight: "10px",marginBottom:"10px" }} // Adjust style as needed
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default FileInput;
